import { PropertySearchInput } from "@/components/Home/Hero/Search";
import { Button } from "@/components/ui/Button";
import { useSearch } from "@/contexts/SearchContext";
import {
  PropertyListingViewType,
  PropertyPurposeType,
} from "@/enums/property.enum";
import clsx from "clsx";
import { ChevronLeft } from "lucide-react";
import { PropertyAmenitiesFilter } from "../Filter/Amenities";
import { PropertyAreaFilter } from "../Filter/Area";
import { PropertyBadgeFilter } from "../Filter/Badge";
import { PropertyBedRoomAndBathroomFilter } from "../Filter/BedBath";
import { PropertyFurnishingFilter } from "../Filter/Furnishing";
import { PropertyListingTypeFilter } from "../Filter/Listing";
import { PropertyPriceFilter } from "../Filter/Price";
import { PropertyTypeFilter } from "../Filter/Property";
import { RentalPeriodFilter } from "../Filter/RentalPeriod";
import { PropertyTourFilter } from "../Filter/Tour";
import { SwitchPropertyView } from "./SwitchPropertyView";

// TODO: REFACTOR THIS
export const FilterHeader = () => {
  const { view, purpose, updateView, locations, updateLocations, listing } =
    useSearch();

  return (
    <div
      className={clsx(
        "relative flex flex-col h-full space-y-2 overflow-visible py-2",
        {
          "max-w-screen-xl m-auto bg-background":
            view !== PropertyListingViewType.MAP,
          "px-2 bg-transparent": view === PropertyListingViewType.MAP,
        }
      )}
    >
      <div className="h-10 sm:min-h-11 sm:h-full  flex gap-2 ">
        {view === PropertyListingViewType.MAP && (
          <Button
            size={"icon"}
            variant={"secondary"}
            className="w-10 block sm:hidden"
            onClick={() => updateView(PropertyListingViewType.LIST)}
          >
            <ChevronLeft />
          </Button>
        )}
        <div className="bg-background h-full w-full  rounded-md  ">
          <PropertySearchInput value={locations} onChange={updateLocations} />
        </div>
      </div>

      <div className="sm:hidden">
        <div
          className="flex overflow-x-auto scrollbar-hide"
          style={{
            msOverflowStyle: "none" /* IE and Edge */,
            scrollbarWidth: "none" /* Firefox */,
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div className="flex">
            <div className={"flex-none pl-1"}>
              <PropertyListingTypeFilter
                variant="drawer"
                key={"listing-type-filter"}
              />
            </div>
            {listing.type?.endsWith("rent") && (
              <div className={"flex-none pl-1"}>
                <RentalPeriodFilter
                  variant="drawer"
                  key={"rental-duration-filter"}
                />
              </div>
            )}
            <div className={"flex-none pl-1"}>
              <PropertyFurnishingFilter
                variant="drawer"
                key={"furnishing-type-filter"}
              />
            </div>
            <div className={"flex-none pl-1"}>
              <PropertyBadgeFilter variant="drawer" key={"badges-filter"} />
            </div>
            <div className={"flex-none pl-2"}>
              <PropertyTypeFilter
                variant="drawer"
                key={"property-type-filter"}
              />
            </div>
            <div className={"flex-none pl-2"}>
              <PropertyPriceFilter variant="drawer" key={"price-filter"} />
            </div>
            {purpose !== PropertyPurposeType.COMMERCIAL && (
              <div className={"flex-none pl-2"}>
                <PropertyBedRoomAndBathroomFilter
                  variant="drawer"
                  key={"bed-and-bathroom-filter"}
                />
              </div>
            )}
            <div className={"flex-none pl-2"}>
              <PropertyAreaFilter variant="drawer" key={"area-filter"} />
            </div>
            <div className={"flex-none pl-2"}>
              <PropertyAmenitiesFilter
                variant="drawer"
                key={"amenities-filter"}
              />
            </div>
            <div className={"flex-none pl-2"}>
              <PropertyTourFilter variant="drawer" key={"tour-filter"} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="gap-2 h-full hidden sm:flex lg:justify-center w-full overflow-x-auto"
        style={{
          msOverflowStyle: "none" /* IE and Edge */,
          scrollbarWidth: "none" /* Firefox */,
          WebkitOverflowScrolling: "touch",
        }}
      >
        <PropertyListingTypeFilter
          variant="plain"
          key={"listing-type-filter"}
        />
        <PropertyTypeFilter variant="plain" />
        {listing.type?.endsWith("rent") && (
          <RentalPeriodFilter variant="plain" />
        )}
        <PropertyFurnishingFilter variant="popover" />
        <PropertyBadgeFilter variant="popover" key={"badges-filter"} />
        {purpose !== PropertyPurposeType.COMMERCIAL && (
          <PropertyBedRoomAndBathroomFilter variant="popover" />
        )}
        <PropertyPriceFilter variant="popover" />
        <PropertyAreaFilter variant="popover" />
        <PropertyAmenitiesFilter variant="popover" />
        <PropertyTourFilter variant="plain" />
        {view === PropertyListingViewType.MAP && <SwitchPropertyView />}
      </div>
    </div>
  );
};
